import { PubSub } from "tsfront/pubsub"

export const pubsub_ = new PubSub()

export const authListenerId = 'AuthListener'
export const langListenerId = 'LangListener'
export const PageLayoutChangeId = 'PageLayoutChangeId'
